import React, { useReducer, useRef } from 'react'
import { TranslateContextProvider } from 'client/common/translator'
import { View } from './components/view/View'
import { ChakraProvider } from '@chakra-ui/react'
import { chemistryTheme, Container } from 'chemistry'
import { productsReducer } from './store/reducer'
import { onLoadProducts, clearProductsState } from './store/actions'
import throttle from '../../common/throttle'

const Component = props => {
  const crossSellRef = useRef()

  const [productsStore, dispatchProducts] = useReducer(productsReducer, {
    products: { collection: [] },
    category: {},
    productId: null
  })

  const loadProducts = item =>
    throttle(
      () =>
        onLoadProducts({
          ...props,
          ...item,
          dispatchProducts
        }),
      300
    )

  const clearProducts = clearProductsState({ dispatchProducts })

  return (
    <ChakraProvider resetCSS={false} theme={chemistryTheme}>
      <TranslateContextProvider translations={props.translations}>
        <div className='buyList' ref={crossSellRef}>
          <Container>
            <View
              {...{
                ...props,
                data: productsStore,
                loading: productsStore.loading,
                loadProducts,
                clearProducts
              }}
            />
          </Container>
        </div>
      </TranslateContextProvider>
    </ChakraProvider>
  )
}

export default { Component }
